import { Link } from 'react-router-dom';

const footerLinks = {
  内容导航: [
    { label: '奢华航班', href: '/category/luxury-flights' },
    { label: '特色航线', href: '/category/featured-routes' },
    { label: '飞行攻略', href: '/category/flight-tips' },
    { label: '机场指南', href: '/category/airport-guide' },
  ],
  关于我们: [
    { label: '品牌故事', href: '/about' },
    { label: '联系方式', href: '/about#contact' },
    { label: '发展历程', href: '/about#milestones' },
  ],
  更多资源: [
    { label: '航空文化', href: '/category/aviation-culture' },
    { label: '里程攻略', href: '/category/flight-tips' },
    { label: '常旅客指南', href: '/category/flight-tips' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="font-heading text-xl font-semibold text-foreground-900">
                诱人的飞行
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                探索全球最具吸引力的航空旅行体验，让每一次起飞都成为难忘旅程的开始。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-red-packet-line text-lg"></i>
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-medium text-foreground-900 mb-3">{title}</h4>
                <ul className="flex flex-col gap-2">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 诱人的飞行. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Cookie 政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}